import cmsApi from '@src/services/cms-api';

const CMS_API = 'https://jxsj.xoyo.com/api.php';
const CMS_CATEGORY_ID = 7884;

export const PAGE_CMS_IDS = Object.freeze([11984, 11985, 11986, 11987, 11988]);

let articleMapPromise = null;

const getArticleMap = () => {
  if (!articleMapPromise) {
    const requestPromise = cmsApi.getArticleList({
      api: CMS_API,
      categoryId: CMS_CATEGORY_ID,
      pageNum: 1,
      pageSize: 999,
      moreInfo: 1
    });

    articleMapPromise = requestPromise
      .then(({ list = [] }) => {
        return list.reduce((articleMap, article) => {
          const articleId = Number(article.articleId);

          if (PAGE_CMS_IDS.indexOf(articleId) !== -1) {
            articleMap[articleId] = article;
          }

          return articleMap;
        }, {});
      })
      .catch(error => {
        articleMapPromise = null;
        throw error;
      });
  }

  return articleMapPromise;
};

export const getPageCmsArticle = articleId => {
  return getArticleMap().then(articleMap => articleMap[Number(articleId)] || null);
};
